import { useTranslation } from "react-i18next";
import {
  Carousel,
  DynamicCardCTAStyle,
  DynamicCardProps,
  DynamicCardType,
} from "src/types";
import { useTheme, useMediaQuery } from "@mui/material";
import { selectorCarousel } from "src/storage";
import { useRecoilValue } from "recoil";
import { useEffect, useMemo, useState } from "react";
import { lowerLanguage } from "src/i18n";
import { DownloadIcon } from "src/assets";

import "./landing-pv-section4.scss";

export const usePvSection4 = () => {
  const { t } = useTranslation();

  const carousels = useRecoilValue(selectorCarousel);
  const [carouselItemList, setCarouselItemList] = useState<DynamicCardProps[]>(
    []
  );

  useEffect(() => {
    const carouselsItems = carousels?.filter(
      (carousel) => !carousel.carouselCode.toUpperCase().includes("CAR_PRD_")
    );

    setCarouselItemList(carouselsItems?.map(createProduct) || []);
  }, [carousels]);

  const createProduct = (carousel: Carousel): DynamicCardProps => {
    const link = carousel.link[lowerLanguage];
    return {
      carouselCode: carousel.carouselCode,
      type: DynamicCardType.tile,
      title: carousel.title[lowerLanguage],
      description: carousel.description[lowerLanguage],
      image: carousel.imagePath,
      ctaLabel: carousel.actionTitle,
      ctaIcon: DownloadIcon,
      ctaStyle: DynamicCardCTAStyle.unfill,
      tagLabel: t("landing.section6.in_agenzia"),
      action: link
        ? () => {
            window.open(link.replaceAll('"', "").toString(), "_blank");
          }
        : () => {},
      enableTMModal: false,
    };
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));

  const reduceRecipes = (
    acc: DynamicCardProps[][],
    cur: DynamicCardProps,
    index: number,
    array: DynamicCardProps[]
  ) => {
    const groupIndex = Math.floor(index / 3);
    if (!acc[groupIndex]) acc[groupIndex] = [];
    acc[groupIndex].push(cur);

    if (index === array.length - 1 && acc[groupIndex].length < 3) {
      let i = 0;
      while (acc[groupIndex].length < 3) {
        acc[groupIndex].push(array[i]);
        i++;
      }
    }

    return acc;
  };

  const groupedItems = useMemo(() => {
    if (isMobile) {
      return carouselItemList.map((item) => [item]);
    }

    const filteredItems = carouselItemList.filter(
      (carousel) => !carousel.carouselCode.includes("CAR_MKT")
    );

    return filteredItems.reduce(reduceRecipes, []);
  }, [carouselItemList, isMobile]);

  return { groupedItems, t };
};
